var map = {
	"./cn/长城书院/wap.svg": "pm2L",
	"./en/长城书院/wap.svg": "0j6I"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "93s+";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/长城书院\/wap\.svg$
// module id = 93s+
// module chunks = 16